import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import cpp from '../assets/cpp.png';
import css from '../assets/css.png';
import java from '../assets/java.png';
import tailwind from '../assets/tailwind.png';
import mongodb from '../assets/mongodb.png';
import firebase from '../assets/firebase.png';
import git from '../assets/git.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import node from '../assets/node.png';
import react from '../assets/react.png';
import redux from '../assets/redux.png';
import sass from '../assets/sass.png';
import typescript from '../assets/typescript.png';
import about01 from '../assets/about01.png';
import about02 from '../assets/about02.png';
import about03 from '../assets/about03.png';
import about04 from '../assets/about04.png';
import profile from '../assets/profile.png';
import logo from '../assets/logo.png';
import circle from '../assets/circle.svg';


// eslint-disable-next-line import/no-anonymous-default-export
export default {
  email,
  mobile,
  cpp,
  css,
  java,
  tailwind,
  mongodb,
  firebase,
  git,
  html,
  javascript,
  node,
  react,
  redux,
  sass,
  typescript,
  about01,
  about02,
  about03,
  about04,
  profile,
  logo,
  circle

};